module.exports = __webpack_public_path__ + "static/media/useCase23x.bd601f66.png";